import { DialogActions, Grid, CircularProgress } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { parseErrorMessage } from '../../../../../../core/api/api.context';
import { TwoPaneModalContent } from '../../../../../../ui/components/pure/modal-content/two-pane-modal-content.component';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';
import { useBookOrderActionContext } from '../book-order-action.context';
import { AllStepsLeftSide } from '../shared-components/all-steps-left-side/all-steps-left-side.component';
import { SectionTitle } from '../shared-components/section-title/section-title.component';

export function BookingProgressStep() {
  const { state, handlers } = useBookOrderActionContext();

  if (state.current !== 'BOOKING_IN_PROGRESS') {
    return null;
  }

  return (
    <>
      <TwoPaneModalContent
        leftDesktopWidth={4}
        rigthDesktopWidth={8}
        flexibleWidthPane="right"
        leftContent={() => <AllStepsLeftSide disableProjectSelector />}
        rightContent={() => (
          <Grid
            container
            sx={{
              justifyContent: 'flex-start',
              flexDirection: 'column'
            }}
          >
            <Grid
              container
              style={{
                padding: '32px 16px',
                marginLeft: 0,
                marginRight: 0,
                width: '100%'
              }}
              spacing={3}
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexDirection: 'column'
              }}
            >
              <Grid>
                <SectionTitle value="Booking Order" />
              </Grid>

              {state.error ? (
                <Grid style={{ width: '100%' }}>
                  <Alert variant="outlined" severity="error">
                    <AlertTitle>Booking Failed</AlertTitle>
                    Error {state.error.statusCode}: {parseErrorMessage(state.error.message)}
                  </Alert>
                </Grid>
              ) : (
                <Grid style={{ padding: '32px 0' }}>
                  <CircularProgress size={32} color="primary" />
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      />
      {state.error && (
        <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
          <TextButton color="secondary" variant="outlined" size="small" onClick={handlers.onCancelIntent}>
            Cancel
          </TextButton>
        </DialogActions>
      )}
    </>
  );
}
